import React from 'react';
import {Link} from "react-router-dom";

function Unauthorized(){
    return(
        <>
            <section className="relative py-20 sm:py-32 lg:py-64 overflow-hidden">

                <div className="relative container px-4 mx-auto">
                    <div className="sm:flex items-start justify-center max-w-5xl mx-auto">

                        <div className="max-w-xs md:max-w-sm lg:max-w-2xl">
                            <h1 className="font-heading text-4xl xs:text-6xl md:text-7xl font-bold text-gray-900 mb-6">
                                <span>Oh no!</span>
                                <span className="font-serif italic">Error 404</span>
                            </h1>
                            <p className="max-w-lg text-xl font-semibold text-gray-500 mb-14">Sorry, the page you are
                                looking for doesn't exist or has been moved. Try searching our site:</p>
                            <Link to='/' className="relative group inline-block py-3 px-5 text-center text-sm font-semibold text-orange-50 bg-orange-900 rounded-full overflow-hidden"
                               >
                                <div
                                    className="absolute top-0 right-full w-full h-full bg-gray-900 transform group-hover:translate-x-full group-hover:scale-102 transition duration-500"></div>
                                <span className="relative">Take me home</span>
                            </Link>
                        </div>
                    </div>
                </div>
            </section>
        </>

    )
}

export default Unauthorized;